import { Link, useNavigate } from "react-router-dom";
import apiAgent from "../api/apiAgent";
import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { loginStatusAtom } from "../atoms";
import { tMsg } from "../components/ToastNotifications";
import { wait } from "@testing-library/user-event/dist/utils";

const Logout = (): JSX.Element => {
  const setLoginStatus = useSetAtom(loginStatusAtom);
  const navigate = useNavigate();

  const logout = async () => {
    try {
      const response = await apiAgent.Auth.logout();
      if (response.status === 200) {
        setLoginStatus(false);
        tMsg.info("You have been logged out. Please login again to continue.");
      }
    } catch (err) {
      // console.log(err);
      tMsg.error("Error logging out");
    }
  };

  useEffect(() => {
    logout();
    let timer = setTimeout(() => navigate("/auth"), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full h-full grid content-center text-lg">
      <div className="text-center space-y-4 flex flex-col justify-center">
        <div className="w-72 font-medium place-self-center">
          You have logged out, or your session has expired. Redirecting to Login
          Page
        </div>
        <div>
          <Link to="/auth" className="text-grayBg font-bold hover:text-white">
            <i className="icon-back_arrow mr-4 font-bold h-12 align-middle" />
            <span className="h-12 align-middle">Return to Login Page</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Logout;
